import React from 'react'
import ImportarArchivo from '../../../Utils/containers/ImportarArchivo'
import { ToastContainer } from 'react-toastify'
import { Row, Col } from 'react-bootstrap'
import { INTERVALO_CORTO } from '../../../../config/settings'
import SolicitudAnalisis from './SolicitudAnalisis'

const MAX_FILE_SIZE = 2 * 1024 * 1024 // 2MB

const ArchivoAnalisis = () => {
  return (
    <>
      <ToastContainer autoClose={INTERVALO_CORTO} />
      <Row>
        <Col md={6} style={{ margin: 'auto' }}>
          <div className='archivo-analisis-container'>
            <ImportarArchivo
              titulo='Importar archivo de análisis'
              label='Cargar archivo de análisis'
              max={MAX_FILE_SIZE}
              textoMax='Máximo: 2MB | Formatos: CSV, XLSX'
            />
          </div>
        </Col>

        <Col md={12}>
          <SolicitudAnalisis />
          {/* <SolicitudAnalisisEmbarque /> */}
        </Col>

      </Row>

    </>
  )
}

export default ArchivoAnalisis
